import { useState, useEffect } from "react"
import { projectFirestore } from "../Firebase/Config"

export const useDocument = (collection, id) => {
    const [document, setDocument] = useState(null)
    const [error, setError] = useState(null)

    // real time data from document
    useEffect(() => {
        const ref = projectFirestore.collection(collection).doc(id);

        const unsubscribe = ref.onSnapshot((snapshot) => {
            if(snapshot.data()){
                setDocument({ 
                    ...snapshot.data(),
                    id: snapshot.id
                })
                setError(null)
            }else{
                setError('Project does not exist')
            }
            
        }, (err) => {
            console.log(err.message)
            setError('failed to get document')
        })

        return () => unsubscribe()
    }, [collection, id])
    
    return { document, error }
}